import React, { useEffect } from 'react';
import { MatchParams } from 'constants/types';
import DesignCanvas from './designCanvas';
import NavigationSidebar from 'components/canvas/navigationSidebar';
import ImageCanvas from './imageCanvas';
import { DisplayMode } from 'components/Experiment/constants';
import {
  useCanvasNavigationTabDisplayMode,
  useSetCanvasNavigationTapDisplayMode,
} from 'redux/hooks/common';
import IngredientCanvas from './ingredientCanvas';
import ScoreCanvas from './scoreCanvas';
import { withWindowResizeAwareness } from 'components/hoc';
import { getAllWellsWithMatchingIngredientStocks } from '../utils';
import { GetRelativePointerPosition } from 'utils/Global';
import { WellIngDTO } from 'business/models/Models';

interface Props extends MatchParams<{}> {
  setZoomInvocker: (functionDelegate: (zoom: number) => void) => void;
}

const CanvasContainer = (props: Props) => {
  const { setZoomInvocker } = props;
  const displayMode = useCanvasNavigationTabDisplayMode();
  const setNavigateDisplayMode = useSetCanvasNavigationTapDisplayMode();

  useEffect(() => () => setNavigateDisplayMode(DisplayMode.IMAGE), []);
  const [highlightedWellNumbers, setHighlightedWellNumbers] = React.useState<
    Array<number>
  >([]);

  const onDesignCanvasMouseUp = (evt: any, wellWithIngredients?: WellIngDTO[]) => {
    if (evt.evt.altKey) {
      const _stg = evt.currentTarget;
      const points = GetRelativePointerPosition(_stg);

      const ingredient = evt.target.attrs.ingredientDetails.find(
        (_ing) =>
          _ing?.type == 'ingredient' && points.y >= _ing.y && points.y <= _ing.y + _ing.h,
      );
      setHighlightedWellNumbers(
        getAllWellsWithMatchingIngredientStocks(
          wellWithIngredients,
          ingredient?.ingredientStockId,
        ),
      );
    } else {
      setHighlightedWellNumbers([]);
    }
  };

  return (
    <div
      id="searchandfilter-index-canvas-main-container"
      className="flex w-full h-[93%] pl-1.5 pr-0 py-0 bg-[#E0E0E0]"
    >
      <div
        id="searchandfilter-index-canvas-navigation-sidebar"
        className="bg-[#E0E0E0] flex flex-col items-end w-[60px] h-full mb-0"
      >
        <NavigationSidebar />
      </div>
      <div
        id="searchandfilter-index-canvas-details-wrapper"
        className="flex flex-column content-width bg-light"
      >
        <div
          id="searchandfilter-index-canvas-details-container"
          className="flex flex-column w-full h-full"
        >
          <div
            id="searchandfilter-index-canvas-details-sub-container"
            className="flex flex-column w-full h-full"
          >
            <div
              id="searchandfilter-index-canvas-details-design-canvas-section"
              className={`${displayMode === DisplayMode.DESIGN ? 'block' : 'hidden'}`}
            >
              {displayMode === DisplayMode.DESIGN && (
                <DesignCanvas
                  setZoomInvocker={setZoomInvocker}
                  displayMode={displayMode}
                  onCanvasMouseUp={onDesignCanvasMouseUp}
                  highlightedWellNumbers={highlightedWellNumbers}
                />
              )}
            </div>
            <div
              id="searchandfilter-index-canvas-details-image-canvas-section"
              className={`${displayMode === DisplayMode.IMAGE ? 'block' : 'hidden'}`}
            >
              {displayMode === DisplayMode.IMAGE && (
                <ImageCanvas setZoomInvocker={setZoomInvocker} />
              )}
            </div>
            <div
              id="searchandfilter-index-canvas-details-ingredient-canvas-section"
              className={`${
                displayMode === DisplayMode.WELLINGREDIENT ? 'block' : 'hidden'
              }`}
            >
              {displayMode === DisplayMode.WELLINGREDIENT && (
                <IngredientCanvas setZoomInvocker={setZoomInvocker} />
              )}
            </div>
            <div
              id="searchandfilter-index-canvas-details-score-canvas-section"
              className={`${displayMode === DisplayMode.SCORE ? 'block' : 'hidden'}`}
            >
              {displayMode === DisplayMode.SCORE && (
                <ScoreCanvas setZoomInvocker={setZoomInvocker} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withWindowResizeAwareness(CanvasContainer);
